'use strict'

const addComponentEventListener = require('../addComponentEventListener')
const { selectCurrentRecord } = require('../../dataset-controller/rootReducer')

module.exports = ({ getState, services, errorBoundaries }) => {
  const itemReady = (actions, api, component) => (
    scoped$w,
    itemData,
    index
  ) => {
    const scopeId = { componentId: component.uniqueId, itemId: itemData._id }
    const { scopeStore, scopeFactory } = services()
    const scope = scopeFactory.createFixedItemScope(scopeId, itemData)
    scopeStore.setScope(scopeId, scope)
    scope.pageReady(scoped$w.scoped)
  }

  const itemRemoved = component => itemData => {
    const scopeId = { componentId: component.uniqueId, itemId: itemData._id }
    services().scopeStore.removeScope(scopeId)
  }

  const refreshView = async (
    { connectionConfig: { properties }, component },
    actions
  ) => {
    const { items: newItems } = await actions.fetchCurrentItems(getState())

    component.data = newItems
  }

  return {
    isValidContext({ connectionConfig }) {
      return true
    },

    bindToComponent(
      { connectionConfig: { properties, events, filters }, component },
      actions,
      api
    ) {
      addComponentEventListener(
        component,
        'onItemReady',
        itemReady(actions, api, component),
        errorBoundaries
      )
      addComponentEventListener(
        component,
        'onItemRemoved',
        itemRemoved(component),
        errorBoundaries
      )
    },

    currentRecordModified({ component }, actions, updatedFields) {
      const updatedItem = selectCurrentRecord(getState())
      const existingItems = component.data || []

      const newItems = existingItems.map(
        existingItem =>
          existingItem._id === updatedItem._id ? updatedItem : existingItem
      )
      component.data = newItems
    },

    recordSetLoaded: refreshView,

    currentViewChanged: refreshView,

    currentIndexChanged(componentAdapterContext, actions, isNewRecord) {}
  }
}



// WEBPACK FOOTER //
// ./adapters/repeater/connectedRepeaterAdapter.js